import React, { useState } from 'react';
import styles from './FileUploadIcon.module.scss';

export interface FileUploadIconProps {
    onFileUpload: (file: File) => void;
}

const FileUploadIcon = (props: FileUploadIconProps) => {
    const inputRef = React.createRef<HTMLInputElement>();
    const { onFileUpload } = props;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_selectedFile, setSelectedFile] = useState<File | null>(null);

    const handleUpload = () => {
        if (inputRef.current) {
            inputRef.current.click();
        }
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setSelectedFile(file);
            onFileUpload(file);
        }
    };

    return (
        <div className={styles['file-upload-icon']} onClick={handleUpload}>
            <span className="Appkit4-icon icon-upload-light-outline"></span>
            <input ref={inputRef} type="file" onChange={handleFileChange} />
        </div>
    );
};

export default FileUploadIcon;
